'use strict';

function Forms() {

    /********************************/
    // init forms
    /********************************/
    this.initForms = function () {
        this.formGroups();
        this.mandatoryFields();
    };

    /********************************/
    // form groups
    /********************************/
    this.formGroups = function () {
        $('input[type="text"], input[type="submit"], select, textarea').each(function () {
            if ($(this).parent().is('td')) {
                $(this).wrap('<div class="form-group"/>');
            }

            if ($(this).attr('type') !== 'submit') {
                var attr = $(this).attr('data-ttip');

                if (typeof attr !== typeof undefined && attr !== false) {
                    $(this).after('<span class="help-block">' + attr + '</span>');
                }
            }
        });
        $('.form-group').each(function () {
            $(this).find('input[type="text"], select, textarea').removeClass('form-control').addClass('form-control');
            $(this).find('input[type="submit"]').each(function(){
                if($(this).attr('disabled') === 'disabled') {
                    $(this).addClass('btn btn-default disabled');
                }
                if(!$(this).hasClass('sv-btn')) {
                    $(this).addClass('sv-btn sv-btn-primary');
                }
            });
        });
    };

    /********************************/
    // mandatory fields
    /********************************/
    this.mandatoryFields = function () {
        $('.forminmand').attr({placeholder: 'required'}).before('<span class="sr-only">Required field</span>');
    };
}